import { useState } from 'react';

import { InputAutoComplete } from './InputAutoComplete';

interface TagInputProps {
  tags: string[];
  onChange: (tags: string[]) => void;
}

export function TagInput({ tags, onChange }: TagInputProps) {
  const [inputValue, setInputValue] = useState('');
  const handleInputChange = (value: string) => {
    setInputValue(value);
  };

  const addTag = (value: string) => {
    if (value) {
      const currentTags = Array.isArray(tags) ? tags : [tags].filter(Boolean);
      if (!currentTags.includes(value)) {
        onChange([...currentTags, value]);
        setInputValue('');
      }
    }
  };

  const handleEnter = () => {
    addTag(inputValue);
  };

  const handleSelect = (selectedValue: string) => {
    addTag(selectedValue);
  };

  const removeTag = (tagToRemove: string) => {
    const currentTags = Array.isArray(tags) ? tags : [tags].filter(Boolean);
    const newTags = currentTags.filter(tag => tag !== tagToRemove);
    onChange(newTags);
  };

  return (
    <div className="tag-input mt-3 pt-1 bg-gray">
      <div className="tags-container mb-2">
        {Array.isArray(tags) ? (
          tags.map((tag, index) => (
            <span key={`key-${tag}-${index}`} className="tag px-1 whitespace-nowrap">
              {tag}
              <button className="ml-1" onClick={() => removeTag(tag)}>
                &times;
              </button>
            </span>
          ))
        ) : (
          <span className="tag px-1 whitespace-nowrap">
            {tags}
            <button className="ml-1" onClick={() => removeTag(tags as string)}>
              &times;
            </button>
          </span>
        )}
      </div>
      <InputAutoComplete
        value={inputValue}
        placeholder="Add a tag..."
        onChange={handleInputChange}
        onEnter={handleEnter}
        onSelect={handleSelect}
      />
    </div>
  );
}
